import styled from '@emotion/styled';
import { css } from 'theme-ui';
import RawHtml from '../../components/RawHtml';
import pxToRem from '../../utils/pixelsToRem';
import headerPack from './headers';

export const StyledHTML = styled.div(
  css({
    p: {
      marginBottom: '2rem',
      letterSpacing: '0.05em',
      lineHeight: '1.5rem',
    },
    ul: {
      listStyleType: 'disc',
      paddingLeft: '3rem',
      li: {
        marginBottom: '2rem',
      },
    },
    'p > a': {
      '&[href^=mailto]': {
        color: 'secondaryGreen',
        textDecoration: 'none',
        '@media print': {
          textDecoration: 'underline !important',
          color: 'text',
        },

        '&:hover': {
          textDecoration: 'underline',
        },
      },
      '&:not([href^=mailto])': {
        display: 'inline-block',
        width: 'fit-content',
        padding: ['0.25rem 1rem', '0.5rem 2.5rem'],
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '2.5rem',
        letterSpacing: '0.035em',
        textDecoration: 'none',
        marginRight: ['6px', '12px'],

        '& > b': {
          fontWeight: 400,
        },

        '&:not(:last-child)': {
          backgroundColor: 'white',
          color: 'black',

          '&:hover': {
            color: 'text',
            backgroundColor: 'focus',
          },
        },
        '&:last-child': {
          border: '1px solid white',
          color: 'white',
          padding: ['calc(0.25rem - 1px) 1rem', 'calc(0.5rem - 1px) 2.5rem'],

          '&:hover': {
            color: 'text',
            backgroundColor: 'focus',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'focus',
          },
        },
      },
    },
  }),
);

export const LightRawHtml = styled(RawHtml)(
  css({
    lineHeight: pxToRem(28),

    '& p': {
      mb: '28px',

      '&:last-child': {
        mb: 0,
      },
    },

    '& a': {
      color: 'secondaryGreen',
      textDecoration: 'none',
      '@media print': {
        textDecoration: 'underline !important',
        color: '#1A3A35 !important',
      },

      '&:hover': {
        textDecoration: 'underline',
      },
    },

    img: {
      width: '50%',
      height: 'auto',
    },

    ...headerPack,
  }),
);
